module.exports = __webpack_public_path__ + "fonts/4b96e8db-6bb0-4bbf-8561-ad1668425256.e7744ea.woff";